import { useContext } from 'react'
import { SignupContext } from './signup.context'

export function useSignupDraft() {
  const context = useContext(SignupContext)
  if (!context) {
    throw new Error('useSignupDraft must be used within SignupProvider')
  }
  return context
}

export function splitFullName(fullName: string) {
  const parts = fullName.trim().split(/\s+/).filter(Boolean)
  return {
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' '),
  }
}
